import {createStyles} from '@mantine/core';
import React from 'react';

import {ProcedureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import getProcedureUIString, {ProceduresStringKeys, StringCase} from 'procedures/ProceduresStringKeys';
import {
  isFeatureEnabledForProcedureType,
  ProceduresFeature,
} from 'procedures/utils/ProcedureCapabilityManagementHelpers';
import {GRAY, NEAR_BLACK} from 'ui-library/Colors';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

const useStyles = createStyles(() => ({
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    minHeight: 220,
    gap: 10,
  },
  emptyStateIcon: {
    fontSize: 52,
    color: GRAY,
  },
  emptyStateText: {
    fontSize: 14,
    color: NEAR_BLACK,
    width: 250,
    textAlign: 'center',
    whiteSpace: 'normal',
  },
}));

export function ParameterLibraryEmptyState(): JSX.Element {
  const {classes} = useStyles();

  const recipeLabel = getProcedureUIString(ProceduresStringKeys.PROCEDURE, ProcedureType.RECIPE, {
    stringCase: StringCase.LOWER,
    plural: true,
  });
  const assayLabel = getProcedureUIString(ProceduresStringKeys.PROCEDURE, ProcedureType.ASSAY, {
    stringCase: StringCase.LOWER,
    plural: true,
  });
  const parts: Array<string> = [];
  if (isFeatureEnabledForProcedureType(ProcedureType.RECIPE, ProceduresFeature.OPEN)) {
    parts.push(recipeLabel);
  }
  if (isFeatureEnabledForProcedureType(ProcedureType.ASSAY, ProceduresFeature.OPEN)) {
    parts.push(assayLabel);
  }
  const text =
    parts.length === 0
      ? 'Build a standardized list of parameters here.'
      : `Build a standardized list of parameters here for your ${parts.length === 1 ? parts[0] : `${parts[0]} and ${parts[1]}`}.`;

  return (
    <div className={classes.emptyState}>
      <BenchlingIcon icon="parameters" className={classes.emptyStateIcon} />
      <span className={classes.emptyStateText}>{text}</span>
    </div>
  );
}
